import { useI18n } from '@/i18n'
import { Badge } from './Badge'

export function OptionalBadge() {
  const { t } = useI18n()

  return (
    <Badge variant="neutral" size="sm" class="ml-2 align-middle">
      {t('common.optional')}
    </Badge>
  )
}
